import ButtonStackWidget from './../ButtonStackWidget';
import { ITEM } from "@mm/constants/widgets";

export default class ListItem extends ButtonStackWidget {
  static make(pageId, content, sortOrder) {
    return {
      ...super.make(pageId, ITEM, sortOrder),
      ...content,
    };
  }
}
